// extracted by mini-css-extract-plugin
module.exports = {"header":"S6f8j","logo":"be3Og","loginHeader":"nnGV6","loginHeader-image":"T0QXA","loginHeader-description":"c2N2p","loginHeader-description-text":"kApgu"};